<template>
<!-- clase move creada para cambiar el icono del cursor a move -->
  <b-row class="table-constructor">
    <b-col align-self="center">
      <ckeditor contenteditable="true" align-self="center" :editor="editor" v-model="dataEditor" :config="editorConfig"></ckeditor>
    </b-col>
    <!-- componente de botón de opciones del elemento  -->
    <options-element :index-element="idElement" :index-column="idColumn"></options-element> 
  </b-row>
</template>
<script>
import InlineEditor from '@ckeditor/ckeditor5-build-inline/build/ckeditor';
import OptionsElement from './OptionsElement';
export default {
  name: "Tabla",
  props:{
    content: {
      type:String,
      default: ''
    },
    idElement: {type:Number}, // Se obtiene posición en el arreglo matriz
    idColumn: { type:Number, default: null } // se obtiene posición de la columna en caso de que esté posicionada en una
  },
  components: {OptionsElement},
  data() {
    return {
      editor: InlineEditor,
      dataEditor: this.content,
      language: 'es',
      editorConfig: { // Configuración del toolbar del editor de texto
        toolbar: ['insertTable','bold', 'italic', 'alignment'],
        placeholder: "Inserte la Tabla" //add place
      }
    };
  },
  watch: {
    dataEditor: function(aft) {
      // se actualiza en el $store el contendio del parrafo con referencia a su posición en el arreglo matriz y si está posicionado dentro de una columna.
      this.$store.dispatch('constructor/updateContentElement',{indexElement: this.idElement, data: aft,field: 'content', indexColumns: this.idColumn})
    }
  }
};
</script>
<style lang="scss" scoped>

  .btn-constructor-manage-element {
      position: absolute;
      right: -1.5rem;
      top: .3rem;
  }
  .table-constructor{
    border-style:dashed;
    border-color: #d6d6d6;
    border-width: thin;
    border-radius: .2rem;
    margin: 5px;
    height: 100%;

    th span:hover{
      cursor:text;
    }
  }
  .ck-focused{
    border: none !important;
    box-shadow: none !important;
  }
  
</style>
